import { Flex, Box, useColorModeValue, Link } from "@chakra-ui/react";

export default function Footer({ activePage, displaySidebar }: any) {
  const ap = activePage.activePage;

  return (
    <Flex
      // h={ap === "Dashboard" ? "20px" : "60px"}
      h="0px"
      display="none"
      justifyContent={{ base: "center", lg: "space-between" }}
      bg={useColorModeValue("gray.1000", "gray.900")}
      alignItems="center"
      // pl={{base: "6", md: displaySidebar ? "7rem" : "0rem"}}
      // ml={{base: "unset",lg: displaySidebar ? "5.5rem" : "0"}}
      // w={{base: "100%",lg: displaySidebar ? "calc(100% - 4rem)" : "100%"}}
      // mr={2}
    >
      <Box
        pl={{ base: "6", md: displaySidebar ? "7rem" : "3rem" }}
        display={{ base: "none", lg: "flex" }}
        gap={6}
        fontSize="sm"
      >
        <Link href="https://www.sequelstring.com/privacypolicy" isExternal>
          Privacy Policy{" "}
        </Link>
        <Link href="#" isExternal>
          Terms and Conditions
        </Link>
        {/* <Link href="#" isExternal>License</Link> */}
      </Box>
      <Box
        fontSize={{ base: "xs", md: "sm" }}
        pr={{ base: "6", md: displaySidebar ? "3rem" : "3rem" }}
        textAlign="center"
      >
        © 2023{" "}
        <Link href="https://www.sequelstring.com/" isExternal>
          Sequelstring AI Pvt. Ltd.
        </Link>
      </Box>
    </Flex>
  );
}
